import React from 'react';
import PropTypes from 'prop-types';
import VoiceMultiSelectFilter from './VoiceMultiSelectFilter';
import { captureAnalytics } from '../../../actions/preload';
import { SCHEDULED_VIA_MAIRA_STATUS } from '../statusFilterConstants';

// Thin wrapper over VoiceMultiSelectFilter; sends the `statuses` query param.
const VoiceStatusFilter = ({
  updateQuery,
  selectedStatuses,
  setSelectedStatuses,
  options,
}) => {
  const handleChange = (next) => {
    // Fire only when the scheduled value newly enters the selection, so
    // unrelated Status changes made while it stays selected don't inflate the
    // metric with repeat events.
    const newlySelected = next.includes(SCHEDULED_VIA_MAIRA_STATUS)
      && !selectedStatuses.includes(SCHEDULED_VIA_MAIRA_STATUS);
    setSelectedStatuses(next);
    if (newlySelected) {
      captureAnalytics('maira_scheduling_filter_applied', {
        outcomes: ['scheduled'],
        statuses: next,
        count: 1,
      });
    }
  };

  return (
    <VoiceMultiSelectFilter
      updateQuery={updateQuery}
      queryKey="statuses"
      placeholder="Status"
      value={selectedStatuses}
      setValue={handleChange}
      options={options}
      selectionType="statuses"
    />
  );
};

VoiceStatusFilter.defaultProps = {
  updateQuery: () => {},
  selectedStatuses: [],
  setSelectedStatuses: () => {},
  options: [],
};

VoiceStatusFilter.propTypes = {
  updateQuery: PropTypes.func,
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  setSelectedStatuses: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default VoiceStatusFilter;
